import React from 'react'
import { Link } from 'react-router-dom'

export function NotFoundPage() {
  React.useEffect(() => {
    document.title = "Siden blev ikke fundet - Frejlev Auto v/ Jacob Kvist"
  }, [])

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4 py-16 bg-gray-50 text-gray-900">
      <div className="w-20 h-20 rounded-full bg-emerald-50 text-[#5cbe4f] flex items-center justify-center text-4xl mb-6">
        <i className="fa-solid fa-triangle-exclamation"></i>
      </div>
      
      <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-950 mb-2">404 - Siden blev ikke fundet</h1>
      <p className="text-gray-600 max-w-md mb-8 text-sm sm:text-base">
        Beklager, men den side du leder efter findes ikke eller er blevet flyttet.
      </p>

      <Link
        to="/"
        className="bg-[#5cbe4f] hover:bg-[#4ca83e] text-white font-bold text-sm px-6 py-3 rounded-lg transition-all flex items-center gap-2 shadow-md uppercase tracking-wider"
      >
        <i className="fa-solid fa-house"></i>
        <span>Gå til forsiden</span>
      </Link>
    </div>
  )
}

export function ForbiddenPage() {
  React.useEffect(() => {
    document.title = "Adgang nægtet - Frejlev Auto v/ Jacob Kvist"
  }, [])

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4 py-16 bg-gray-50 text-gray-900">
      <div className="w-20 h-20 rounded-full bg-red-50 text-red-500 flex items-center justify-center text-4xl mb-6">
        <i className="fa-solid fa-lock"></i>
      </div>
      
      <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-950 mb-2">403 - Adgang nægtet</h1>
      <p className="text-gray-600 max-w-md mb-8 text-sm sm:text-base">
        Du har ikke tilladelse til at tilgå denne side.
      </p>

      <Link
        to="/"
        className="bg-[#5cbe4f] hover:bg-[#4ca83e] text-white font-bold text-sm px-6 py-3 rounded-lg transition-all flex items-center gap-2 shadow-md uppercase tracking-wider"
      >
        <i className="fa-solid fa-house"></i>
        <span>Gå til forsiden</span>
      </Link>
    </div>
  )
}
